import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { fetchGeoStatus } from 'store/siteSlice';
import GeoBlockedService from 'components/geoBlockedService/geoBlockedService';
import styles from './vault.module.scss';
import DepositTab from './tabs/depositTab';
import WithdrawalTab from './tabs/withdrawalTab';

const Vault: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [activeTab, setActiveTab] = useState<'transfer' | 'withdrawal'>('transfer');

  const config = useAppSelector((state) => state.site.config);
  const isBlocked = config?.geo?.isBlocked;

  useEffect(() => {
    dispatch(fetchGeoStatus());
  }, [dispatch]);

  return (
    <div className={styles.vaultContainer}>
      <div className={styles.tabsContainer}>
        <button
          className={`${styles.tabBtn} ${activeTab === 'transfer' ? styles.active : ''}`}
          onClick={() => setActiveTab('transfer')}
        >
          {t('vault.tabs.transfer', 'Transfer')}
        </button>
        <button
          className={`${styles.tabBtn} ${activeTab === 'withdrawal' ? styles.active : ''}`}
          onClick={() => setActiveTab('withdrawal')}
        >
          {t('vault.tabs.withdrawal', 'Withdrawal')}
        </button>
      </div>

      <div className={styles.tabContent}>
        {isBlocked ? (
          <GeoBlockedService />
        ) : (
          <>
            {activeTab === 'transfer' && <DepositTab onSwap={() => setActiveTab('withdrawal')} />}
            {activeTab === 'withdrawal' && (
              <WithdrawalTab onSwap={() => setActiveTab('transfer')} />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Vault;
